<template lang="pug">
  .b2b-login-password-form-b2b
    login-password-form-generic(
      :logo='logo'
      :next='next'
      :back='back')
</template>

<script>
import B2bLoginPasswordFormGeneric from '@/components/logingeneric/B2bLoginPasswordFormGeneric'

export default {
  name: 'login-password-form-b2b',

  data () {
    return {
      logo: null,
      next: '/login/new-password-final-form',
      back: '/login'
    }
  },
  components: {
    'login-password-form-generic': B2bLoginPasswordFormGeneric
  }

}
</script>
